"use client";

import { Instagram, Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[0, 1, 2, 3].map(i => <li key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse" />)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="group relative inline-flex font-sans text-[0.75rem] uppercase tracking-[0.18em] text-foreground/70 hover:text-primary transition-colors duration-[320ms]">
            <span className="relative">
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-[320ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
export default function TheBoutiqueFooter() {
  const studioLinks = [{
    label: "Our Heritage",
    to: "/OurHeritagePage"
  }, {
    label: "Artistry",
    to: "#"
  }, {
    label: "Sustainability",
    to: "#"
  }, {
    label: "The Journal",
    to: "#"
  }, {
    label: "Press",
    to: "#"
  }];
  const contactLinks = [{
    label: "Consultation",
    to: "#"
  }, {
    label: "Visit Atelier",
    to: "#"
  }, {
    label: "Trade Program",
    to: "#"
  }, {
    label: "(555) 123-4567",
    to: "#"
  }, {
    label: "hello@essenceco.com",
    to: "#"
  }];
  const legalLinks = [{
    label: "Privacy",
    to: "#"
  }, {
    label: "Terms",
    to: "#"
  }, {
    label: "Care Guide",
    to: "#"
  }];
  const socials = [{
    label: "Instagram",
    icon: Instagram,
    to: "#"
  }, {
    label: "Linkedin",
    icon: Linkedin,
    to: "#"
  }];
  return <section data-section-id="2085" id="the-boutique-footer" className="relative bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -top-32 -right-32 md:-top-40 md:-right-40 w-[420px] h-[420px] md:w-[560px] md:h-[560px] opacity-10">
        <svg viewBox="0 0 560 560" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <circle cx="560" cy="0" r="120" stroke="currentColor" strokeWidth="1" />
          <circle cx="560" cy="0" r="200" stroke="currentColor" strokeWidth="1" />
          <circle cx="560" cy="0" r="280" stroke="currentColor" strokeWidth="1" />
          <circle cx="560" cy="0" r="360" stroke="currentColor" strokeWidth="1" />
          <circle cx="560" cy="0" r="440" stroke="currentColor" strokeWidth="1" />
          <circle cx="560" cy="0" r="520" stroke="currentColor" strokeWidth="1" />
        </svg>
      </div>

      <div className="relative max-w-[1440px] mx-auto px-8 md:px-12 lg:px-20">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4 flex flex-col gap-8">
            <Link to="/" aria-label="Essence & Co. - Home" className="inline-block">
              <WvcLogo className="h-10 w-auto" />
            </Link>

            <p className="font-default text-foreground/70 text-lg leading-[1.65] max-w-xs">
              Curating rare olfactory experiences through sustainable, artisanal perfumery.
            </p>

            <div className="flex flex-col gap-4">
              <span className="font-sans text-[0.6875rem] md:text-[0.8125rem] tracking-[0.18em] uppercase text-muted-foreground">
                § Follow
              </span>
              <div className="flex items-center gap-5">
                {socials.map((social, i) => {
                const Icon = social.icon;
                return <Link key={social.label} data-index={i} to={social.to} aria-label={social.label} newTab className="text-foreground/60 hover:text-primary transition-colors duration-[240ms]">
                      <Icon strokeWidth={1.25} className="w-5 h-5" />
                    </Link>;
              })}
                {}
                <Link to="#" aria-label="Pinterest" newTab className="text-foreground/60 hover:text-primary transition-colors duration-[240ms]">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="square" strokeLinejoin="miter" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M8 11.5C8 8.5 10 6.5 12.5 6.5C14.5 6.5 16 8 16 10C16 12 14.5 13.5 12.5 13.5C11.5 13.5 11 13 11 13L10 18" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
            {}
            <div className="flex flex-col gap-6">
              <span className="font-sans text-[0.6875rem] md:text-[0.8125rem] tracking-[0.18em] uppercase text-muted-foreground">
                § Collections
              </span>
              <MenuProvider menu_id="25">
                <FooterMenuConsumer />
              </MenuProvider>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <span className="font-sans text-[0.6875rem] md:text-[0.8125rem] tracking-[0.18em] uppercase text-muted-foreground">
                § Atelier
              </span>
              <ul className="flex flex-col gap-3">
                {studioLinks.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="group relative inline-flex font-sans text-[0.75rem] uppercase tracking-[0.18em] text-foreground/70 hover:text-primary transition-colors duration-[320ms]">
                      <span className="relative">
                        {item.label}
                        <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-[320ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </div>

            {}
            <div className="flex flex-col gap-6">
              <span className="font-sans text-[0.6875rem] md:text-[0.8125rem] tracking-[0.18em] uppercase text-muted-foreground">
                § Contact
              </span>
              <ul className="flex flex-col gap-3">
                {contactLinks.map((item, i) => <li key={item.label} data-index={i}>
                    <Link to={item.to} className="group relative inline-flex font-sans text-[0.75rem] uppercase tracking-[0.18em] text-foreground/70 hover:text-primary transition-colors duration-[320ms]">
                      <span className="relative">
                        {item.label}
                        <span className="absolute -bottom-1 left-0 h-px w-0 bg-primary transition-all duration-[320ms] ease-[cubic-bezier(0.65,0,0.35,1)] group-hover:w-full" />
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28 mb-8 flex items-center w-full">
          <div className="flex-1 h-px bg-border" />
          <div className="w-1.5 h-1.5 bg-primary ml-0" />
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-start lg:items-center">
          <div className="lg:col-span-8">
            <p className="font-sans text-[0.75rem] tracking-[0.04em] uppercase text-muted-foreground leading-[1.4]">
              &copy; ESSENCE & CO. 2025 &middot; PARIS, FR &middot; 48.8566&deg; N 2.3522&deg; E
            </p>
          </div>
          <div className="lg:col-span-4 lg:justify-self-end">
            <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
              {legalLinks.map((item, i) => <li key={item.label} data-index={i} className="flex items-center gap-5">
                  <Link to={item.to} className="font-sans text-[0.75rem] tracking-[0.04em] uppercase text-muted-foreground hover:text-primary transition-colors duration-[240ms]">
                    {item.label}
                  </Link>
                  {i < legalLinks.length - 1 && <span aria-hidden="true" className="font-sans text-[0.75rem] text-muted-foreground">
                      &middot;
                    </span>}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}